import { Button } from './button.component';

export * from './button.component';
export default Button;

Button.define('der-ui-button');

declare global {
    interface HTMLElementTagNameMap {
        'der-ui-button': Button;
    }
}
